module.exports = __webpack_public_path__ + "img/startperson.4d003053.png";